import { SalonDate, ExpertTime } from './booking';
import { Language } from './language';

export const BOOKING_GUEST_NAME_MAX_LENGTH = 50;
export const BOOKING_GUEST_PHONE_MAX_LENGTH = 50;
export const BOOKING_COMMENT_MAX_LENGTH = 250;

export interface GetBookingInput {
  salonDate: string;
  expertTime?: string;
}

export type PublicGetBookingInput = {
  salonDate: string;
  expertTime: string;
  bookingId: string;
  [key: string]: string;
};

export interface CreateBookingInput {
  salonDate: SalonDate;
  expertTime: ExpertTime;
  guestName: string;
  guestPhone: string;
  guestEmail: string;
  activityId: string;
  comment: string;
  userConsent: boolean;
  activityName?: string;
  language?: Language;
}

export interface UpdateBookingInput {
  salonDate: SalonDate;
  expertTime: ExpertTime;
  newDate?: string;
  newTime?: string;
  bookingId: string;
  activityId: string;
  guestName: string;
  guestPhone: string;
  guestEmail: string;
  comment: string;
  userConsent: boolean;
  activityName?: string;
  language?: Language;
}

export interface DeleteBookingInput {
  salonDate: SalonDate;
  expertTime: ExpertTime;
  bookingId: string;
}
